import React from "react";
import { ComboBox } from './../../fluent';
export class RoleComboBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = this._mapProps(props);
    }
    componentWillReceiveProps(props) {
        this.setState(this._mapProps(props));
    }
    render() {
        return React.createElement(ComboBox, { label: this.state.label, useComboBoxAsMenuWidth: true, required: this.state.required, disabled: this.state.disabled, options: this.state.rolesCO, onChange: (_, option) => this._onChange(option), errorMessage: this.state.errorMessage, selectedKey: this.state.selectedKey, panelProps: {
                hasCloseButton: true,
                isBlocking: true
            } });
    }
    _mapProps(props) {
        return {
            disabled: props.disabled || false,
            errorMessage: props.errorMessage || '',
            label: props.label,
            required: props.required || false,
            roles: props.roles || [],
            rolesCO: (props.roles || []).map(o => ({ key: o.IdRol, text: o.Nombre })),
            selectedKey: props.selectedKey
        };
    }
    _onChange(option) {
        const roleId = Number(option.key);
        const role = this.state.roles.find(o => o.IdRol == roleId);
        this.props.onChanged(role);
    }
}
